(function () {
  if (!window.jQuery) return;

  var seen = new Set();

  function report(label, stack) {
    var key = label + "|" + (stack || "").split("\n").slice(0, 4).join("");
    if (seen.has(key)) return;
    seen.add(key);
    console.warn("[jquery-canary] " + label, "\n" + stack);
  }

  var original = window.jQuery;

  var wrapped = function () {
    report("jQuery() llamado", new Error().stack);
    return original.apply(this, arguments);
  };

  Object.setPrototypeOf(wrapped, original);
  Object.keys(original).forEach(function (key) {
    try {
      wrapped[key] = original[key];
    } catch (e) {}
  });
  wrapped.fn = original.fn;

  ["ajax", "get", "post", "getJSON"].forEach(function (method) {
    if (typeof original[method] !== "function") return;
    var fn = original[method];
    wrapped[method] = function () {
      report("jQuery." + method + "() llamado", new Error().stack);
      return fn.apply(this, arguments);
    };
  });

  window.jQuery = wrapped;
  window.$ = wrapped;
})();
